import React from 'react';

import { FormElement, FormListItem } from './CommonFormComponents';

/**
 * プレースホルダー付きのセレクトボックス ( メインは検索等で使用する )
 * @props {string}label:ラベル
 * @props {string}value:画面に表示させたいデータ
 * @props {boolean}isRequireIconShow:必須アイコンを表示するか？
 */
export class FieldFormElementsReadOnly extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isRequireIconShow: false,
    };

    if (props.isRequireIconShow === true) {
      this.state.isRequireIconShow = props.isRequireIconShow;
    }
  }

  // 画面表示
  render() {
    return (
      <FormListItem
        label={this.props.label}
        required={this.state.isRequireIconShow}
      >
        <FormElement>
          <span>{this.props.value}</span>
        </FormElement>
      </FormListItem>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FieldFormElementsReadOnly.jsx